import { useEffect, useMemo, useState } from "react"
import { UpgradePlan } from "../../CommonComponents/UpgradePlan"
import {
  Tab,
} from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import {
  DeleteRequest,
  GetRequest,
} from "../../Utils/hooks/ApiHandler"
import useLocalStorageState from "use-local-storage-state"
import { useGetRequest } from "../../Utils/hooks/QueryHandler"
import DeleteModal from "../DeleteModal"
import { toast } from "sonner"
import "./salesOrders.css"
import { SalesHeader } from "./SalesModule/SalesHeader"
import { SalesListing } from "./SalesModule/SalesListing"
import { AuthorizationCard } from "../../CommonComponents/AuthorizationCard"
import { useGetEssentials } from "../../Utils/hooks/useGetEssentials"
import useCommonData from "../../Utils/actions/advanceFilteringAction"
import { useGlobalState } from "../../Utils/hooks/useFilterQueryValue"
import { fetchTemporaryFilterData } from "../../Utils/helpers/commonhelper"

export const SalesOrder = ({ initialSalesId }) => {

  const { customer, setCustomer, headers, extras, navigate, customerId, loginUserId, userType } = useGetEssentials()
  // parsing locally stored metadata
  const salesOrderMetadata = JSON.parse(localStorage.getItem('salesOrderMetadata'))
  // rbac permission grant
  const [PERMISSION, _] = useLocalStorageState('permission');

  const [isMyApproval, setMyApproval] = useState(() => {
    return salesOrderMetadata?.isMyApproval || false
  });
  const [allSalesOrder, setAllSalesOrder] = useState([])
  const [departmentToDelete, setDepartmentToDelete] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [loading, setLoading] = useState(false)
  // States for using pagination
  // Calculate total pages

  const [limit, setLimit] = useState(25)
  const [allOffset, setAllOffset] = useState(0)
  const [myApprovalOffset, setMyApprovalOffset] = useState(0)

  const activeOffset = isMyApproval ? myApprovalOffset : allOffset
  const setActiveOffset = isMyApproval ? setMyApprovalOffset : setAllOffset
  const [search, setSearch] = useState("")
  const params = {
    limit,
    offset: activeOffset,
    search,
  }


  // states to store the filter data
  const [filterStates, setFilterState] = useState([])
  // const lastHeading = localStorage.getItem("sales_last_heading")
  const [heading, setHeading] = useState("All Sales Order")

  // state for storing deals data
  const [deals, setDeals] = useState([])

  // loading state for temporary filter data to be hydrated
  const [tempFilterDataLoading, setTempFilterDataLoading] = useState(false)
  const [salesFilterDataParams, setSalesFilterDataParams] = useGlobalState(
    "salesFilterDataParams",
    { currAdvFilter: null, applyFilterData: {} }
  )

  // curr advance filter to store the current filter type between "apply" and "save as" in advance filter for respective pagination in apply filter
  const [currAdvFilter, setCurrAdvFilter] = useState(
    () => salesFilterDataParams?.currAdvFilter || null
  )

  // global value state for applying the pagination to temporary filter data
  const [salesFilterValues, setSalesFilterValues] = useGlobalState("salesApplyFilterQueryValues")

  // filter state to see the temoporary applied filter data,
  const [tempFilterData, setTempFilterData] = useState(null)
  // state for filter dropdown of quotations
  const [filterDropdown, setFilterDropdown] = useState(false)

  // filter categories to render within the heading dropdown
  const [filterCategories, setFilterCategories] = useState([])
  // state to store the advanced custom filter to fetch data on save
  const [customFilter, setCustomFilter] = useState(null)

  // Add states for filter pagination and search
  const [filterOffset, setFilterOffset] = useState(0)

  // sales permission
  const salesGrant = PERMISSION.sales_order;
  // issalesorder is permission if module doesn't lie within current subscription plan
  const isSalesOrder = salesGrant?.isAuthorized;

  // checking and validating if the last selected filter still exist until then the state initialized would be false and no data or the heading would be renderd
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    if (!isInitialized) {
      const lastHeading = salesOrderMetadata?.filterType?.filterName
      setHeading(lastHeading || "All Sales Order")
      setIsInitialized(true)
    }
  }, [isInitialized, salesOrderMetadata])

  // Save view preference to localStorage
  useEffect(() => {
    localStorage.setItem("salesOrderMetadata", JSON.stringify(
      {
        ...salesOrderMetadata,
        isMyApproval: isMyApproval,
      }
    ))
  }, [isMyApproval])

  // common advance filter api calls that will be needed everywhere
  const { leadOwner, company, contacts } = useCommonData({
    leadOwner: true,
    leadSource: false,
    companies: true,
    contacts: true
  })


  //  filter dropdown options
  const dropdownOptions = [
    { value: "contact_id", label: "Contact", option: contacts },
    { value: "owner_id", label: "Owner", option: leadOwner },
    { value: "company_id", label: "Company Name", option: company },
    { value: "deal_id", label: "Deal", option: deals },
    { value: "sale_no", label: "Sales Number" },
    { value: "approve_by", label: "Approve By", option: leadOwner },
    { value: "shipment_date", label: "Shipment Date", type: "date-range" },
    { value: "order_date", label: "Order Date", type: "date-range" },
    { value: "created_at", label: "Created at", type: "date-range" },
  ]

  // useEffect(() => {
  //   if (tempFilterData !== null) {
  //     setActiveOffset(0)
  //   }
  // }, [tempFilterData])

  // useeffect for deals
  useEffect(() => {
    ; (async () => {
      const res = await GetRequest(
        `common/fetchAllDeals/${customerId}/${loginUserId}`,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      )
      if (!res) return
      if (res.success === false) {
        return
      }
      setDeals(
        res.data?.map((c) => ({
          label: c.deal_name + " " + `(${c.deal_no})`,
          value: c.id,
        }))
      )
    })()
  }, [])

  const applyFilterDataParams = {
    filterValues: salesFilterValues,
    currView: "list",
    offset: activeOffset,
    limit: limit,
    module_name: "sales",
    customerId: customerId,
    loginUserId: loginUserId,
    userType: userType,
    headers: headers,
    extras: extras,
    setTempFilterData: setTempFilterData,
    setLoading: setTempFilterDataLoading,
    setFilterState: setFilterState,
    setFilterDropdown: setFilterDropdown,
  }

  useEffect(() => {
    setSalesFilterDataParams({
      currAdvFilter: currAdvFilter,
      applyFilterData: {
        ...applyFilterDataParams,
        filterValues: salesFilterValues,
        currView: "list",
        offset: activeOffset,
        limit: limit,
      },
    })
  }, [currAdvFilter, salesFilterValues, activeOffset, limit, isMyApproval])

  useEffect(() => {
    if (
      currAdvFilter === "apply" &&
      salesFilterValues?.["filter_values"]?.length > 0 &&
      !isMyApproval
    ) {
      fetchTemporaryFilterData(salesFilterDataParams?.applyFilterData)
    }
  }, [salesFilterDataParams?.applyFilterData, isMyApproval])

  const { endpoint, queryKey } = useMemo(() => {
    if (currAdvFilter === "apply" && !isMyApproval) {
      return {
        endpoint: "",
        queryKey: ""
      }
    }

    // resetting state if current advance filter is null
    setSalesFilterValues({ filter_state: [], filter_values: [] })

    const customFilterId = salesOrderMetadata?.filterType?.id
    const lowerHeading = heading
      ? heading?.toLowerCase()?.split(" ").join("_")
      : heading

    if (isMyApproval) {
      return {
        endpoint: `/sales/fetchMyApprovals/${customerId}/${loginUserId}`,
        queryKey: `fetchApprovalSalesOrder`
      }
    }
    if (!customFilter && !customFilterId) {
      if (lowerHeading === "all_sales_order") {
        return {
          endpoint: `/sales/fetchAllOrders/${customerId}/${loginUserId}/${userType}`,
          queryKey: `fetchSalesOrder`
        }
      }
    }
    if (customFilter || customFilterId) {
      const id = customFilter?.id || customFilterId
      return {
        endpoint: `/sales/fetchAllOrders/${customerId}/${loginUserId}/${userType}/${id}`,
        queryKey:
          `filterQuery${id}`
      }
    }
    return {
      endpoint: "",
      queryKey: ''
    }
  }, [heading, filterCategories, isMyApproval, customFilter, currAdvFilter])

  // Single useGetRequest call
  const {
    data: salesOrderData,
    error,
    refetch: fetchSalesOrder,
    isLoading,
    isError,
  } = useGetRequest(
    endpoint,
    [queryKey, isMyApproval],
    headers,
    extras,
    params
  )

  // storing all contacts to a state to use it in the custom dropdown for the dynamic fields
  useEffect(() => {
    if (currAdvFilter === 'apply') return
    if (
      salesOrderData &&
      salesOrderData.filter_data &&
      salesOrderData.filter_data[0] &&
      salesOrderData.filter_data[0].filter_values
    ) {
      const values = salesOrderData.filter_data[0].filter_values
      const parsedState = JSON.parse(values)
      const filteredArray = parsedState?.map((state) => {
        const dropdownValue = dropdownOptions.find(
          (opt) => opt.value === state.label_name
        )

        return {
          id: state.label_name,
          field: state.label_name, // This is the internal identifier (e.g., "email", "owner")
          label_name: dropdownValue ? dropdownValue.label : state.label_name,
          option: dropdownValue?.option,
          subFilterType: state.label_query,
          value:
            state.label_query === "between"
              ? { start: state.label_value[0], end: state.label_value[1] }
              : state.label_value,
        }
      })

      setFilterState(filteredArray)
    } else {
      setFilterState([])
    }

    setAllSalesOrder(salesOrderData?.data)
    // setTotalCount(salesOrderData?.["total_count"])
  }, [queryKey, salesOrderData, isMyApproval])

  // Confirm delete and call API
  const handleConfirmedDelete = async () => {
    setLoading(true)
    try {
      const item = allSalesOrder.find((d) => d.sales_id === departmentToDelete)

      const res = await DeleteRequest(
        `sales/deleteSalesOrder/${departmentToDelete}/${loginUserId}`,
        { headers },
        extras
      )

      if (res?.status === "success") {
        toast.success(res.message)
        await fetchSalesOrder()
        setLoading(false)
      } else if (res.status === "fail") {
        toast.error(res.message)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      console.error("Delete error:", error)
    } finally {
      setLoading(false)
      setShowDeleteModal(false)
      setDepartmentToDelete(null)
    }
  }

  const columnOptions = [
    // { key: "sn", label: "#",locked: true },
    { key: "sales_order_date", label: "Date" },
    { key: "sale_no", label: "Sales Order#", mandatory: true },
    { key: "quotation_number", label: "Quotation Number" },
    { key: "contact_full_name", label: "Customer Name" },
    { key: "status", label: "Status" },
    { key: "invoiced", label: "Invoiced" },
    // { key: "confirmed", label: "Payment" },
    { key: "items", label: "Amount" },
    { key: "shipment_date", label: "Expected Shipment Date" },
    // { key: "order_status", label: "Order Status" },
    // { key: "delivery_method", label: "Delivery Method" },
  ]
  // Initialize columns for the table - ALL columns visible by default
  const [columns, setColumns] = useState(() => {
    const saved = salesOrderMetadata?.visibleColumns
    const allColumnKeys = columnOptions?.map(col => col.label);
    if (saved) {
      try {
        return saved
      } catch (e) {
        console.error("Error parsing visible columns:", e);
      }
    }
    return allColumnKeys;
  });


  if (!isSalesOrder) {
    return <UpgradePlan moduleName="Sales Order" />
  }

  if (!salesGrant?.isView) {
    return <div style={{ position: "absolute", left: "40%", top: "10rem" }}>
      <AuthorizationCard />
    </div>
  }

  return (
    <>
      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmedDelete}
        isLoading={loading}
        message="Are you sure you want to delete this item?"
      />
      <Tab.Container defaultActiveKey="tab-sales">
        <Tab.Content>
          <Tab.Pane
            className="p-0 pt-0 pb-3"
            eventKey="tab-sales"
            style={{
              border: "none",
              animation: "cardEntry 1s ease-out forwards",
            }}
          >
            <SalesHeader
              isMyApproval={isMyApproval}
              setMyApproval={setMyApproval}
              heading={heading}
              setHeading={setHeading}
              columns={columns}
              setColumns={setColumns}
              columnOptions={columnOptions}
              filterStates={filterStates}
              setFilterState={setFilterState}
              filterCategories={filterCategories}
              setFilterCategories={setFilterCategories}
              filterOffset={filterOffset}
              setFilterOffset={setFilterOffset}
              setTempFilterData={setTempFilterData}
              setCurrAdvFilter={setCurrAdvFilter}
              setActiveOffset={setActiveOffset}
              setSearch={setSearch}
              setCustomFilter={setCustomFilter}
              refetchSales={fetchSalesOrder}
              salesOrderMetadata={salesOrderMetadata}
              dropdownOptions={dropdownOptions}
              filterDropdown={filterDropdown}
              setFilterDropdown={setFilterDropdown}
              filterValues={salesFilterValues?.filter_state}
              setSalesFilterValues={setSalesFilterValues}
            />
            <SalesListing
              isMyApproval={isMyApproval}
              allSalesOrder={allSalesOrder}
              activeOffset={activeOffset}
              setActiveOffset={setActiveOffset}
              salesOrderData={salesOrderData}
              fetchSalesOrder={fetchSalesOrder}
              heading={heading}
              setHeading={setHeading}
              limit={limit}
              setLimit={setLimit}
              isLoading={isLoading}
              columns={columns}
              tempFilterData={tempFilterData}
              initialSalesId={initialSalesId}
            />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container >

    </>
  )
}